module.exports = __webpack_public_path__ + "img/Italian.ef752aca.svg";